import { render, staticRenderFns } from "./commonProblem.vue?vue&type=template&id=2262dcaa&scoped=true"
import script from "./commonProblem.vue?vue&type=script&lang=js"
export * from "./commonProblem.vue?vue&type=script&lang=js"
import style0 from "./commonProblem.vue?vue&type=style&index=0&id=2262dcaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2262dcaa",
  null
  
)

export default component.exports